document.addEventListener('DOMContentLoaded', function () {
  const videoItems = document.querySelectorAll('.video-item');
  const videoPlayer = document.querySelector('#mainVideo');
  const videoTitle = document.querySelector('#videoTitle');
  const videoDescription = document.querySelector('#videoDescription');
  const videoPlayerTitle = document.querySelector('#videoPlayerTitle');
  const copyLinkBtn = document.querySelector('.copy-link'); // دکمه کپی لینک

  // انتخاب ویدیو
  videoItems.forEach(item => {
    item.addEventListener('click', function () {
      const videoUrl = this.getAttribute('data-video-url');
      const title = this.querySelector('h4').textContent;
      const description = this.getAttribute('data-description');
      const posterImage = this.getAttribute('data-poster-image');

      // بروزرسانی ویدیو
      videoPlayer.src = videoUrl;
      videoTitle.textContent = title;
      videoDescription.textContent = description;
      videoPlayer.poster = posterImage;
      videoPlayerTitle.textContent = title;

      // تغییر لینک کپی به لینک صفحه پست
      if (copyLinkBtn) {
        const postLink = this.getAttribute('data-video-link'); // گرفتن لینک صفحه پست از data-video-link
        copyLinkBtn.setAttribute('data-video-link', postLink); // به‌روزرسانی لینک صفحه پست
      }

      // فعال کردن ویدیو فعلی
      videoItems.forEach(i => i.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // عملکرد دکمه کپی لینک
  if (copyLinkBtn) {
    copyLinkBtn.addEventListener('click', () => {
      const videoLink = copyLinkBtn.getAttribute('data-video-link'); // دریافت لینک صفحه پست
      if (videoLink) {
        navigator.clipboard.writeText(videoLink)
          .then(() => {
            alert('لینک کپی شد!');
          })
          .catch(err => {
            console.error('خطا در کپی کردن لینک:', err);
          });
      } else {
        alert('لینک ویدیو موجود نیست.');
      }
    });
  }
});
